
<template>
  <b-modal
    :title="organizationName"
    header-bg-variant="success"
    header-text-variant="light"
    size="lg"
    :visible="showModal"
    centered
    @hidden="reset"
    >
  <template #modal-header-close>
      <h4>X</h4>
    </template>
     <b-row v-show="orgUpdateMemPending">
      <h2  class="u-padding-bottom-20">Updating, please wait ...</h2>
      <pulse-loader :loading="orgUpdateMemPending" :color="spinnerColor" :size="spinnerSize"></pulse-loader>
    </b-row>

    <b-row v-if="!orgUpdateMemPending">
      <b-col>
        <b-form>
        <b>Memberships: </b> <div v-if="selectedMemRec"> {{selectedMemRec.muser.fullName}}</div>

          <b-form-checkbox
            id="isOrgAdminOff"
            v-model="selectedOrgAdmin"
            name="isOrgAdminOff"
            unchecked-value="false"
            switch
            incline
            class="m-3"
            >
            Organization Administrator: Would you like for this user to be able to share, unshare and transfer records?
          </b-form-checkbox>


          <b-form-checkbox
            id="isOrgManagerOff"
            v-model="selectedOrgManager"
            name="isOrgManagerOff"
            unchecked-value="false"
            switch
            incline
            class="m-3"
            >
            Organization Manager: Would you like this user to be able to view all of the records for your organization?
          </b-form-checkbox>
        </b-form>

        <b-form-checkbox
          id="dwUser"
          v-model="selectedDWUser"
          name="dwUser"
          :unchecked-value="false"
          switch
          inline
          class="m-3">
            Data Warehouse User: Would you like this user to be able to access the Lighthouse Data Warehouse application?
        </b-form-checkbox>

        <b-form-checkbox
          id="careCoordinator"
          v-model="selectedCareCoordinator"
          name="careCoordinator"
          :unchecked-value="false"
          switch
          inline
          class="m-3">
          Care Coordinator: Would you like this user to access the Victim Identification tab designed for care coordinators?
        </b-form-checkbox>
      </b-col>
      <b-col>
        <br>
        <b>Created At: </b>  {{ getCreatedAt() }}
        <div v-if="_.isObject(selectedMemRec.createdBy)">
          <b> by: </b> {{ _.get(selectedMemRec, 'createdBy.emailAddress', '') }}
        </div>
        <br>
        <b>Last Updated: </b>  {{ getLastUpdateDate() }}
        <div v-if="_.isObject(selectedMemRec.updatedBy)">
          <b> by: </b> {{ _.get(selectedMemRec, 'updatedBy.emailAddress', '') }}
        </div>
        <br>
      </b-col>
    </b-row>

    <b-alert
      fade
      :show="orgUpdateMemFailure || _.isObject(orgUpdateMemSuccess)"
      :variant="orgUpdateMemFailure ? 'danger' : 'success'"
    >
      <span v-html="apiResponseMessage()"></span>
    </b-alert>

    <div slot="modal-footer" class="w-100">
      <b-button
        v-if="!disableDelete"
          type="button"
          variant="danger"
          size="sm"
          class="float-left"
          @click="orgMemberHandlerDelete"
      >
        <span class="button-text">Delete</span>
      </b-button>
      <span v-else class="text-danger"> This is the primary organization for this user.  It cannot be removed.  </span>
      <b-button
          type="button"
          variant="primary"
          size="sm"
          class="float-right"
          @click="orgMemberHandler"
      >
        <span class="button-text">Update</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'UpdateOrganizationsMemberModal',
  props: {
    selectedMemRec: Object,
    organizationName: String,
    showModal: Boolean,
    disableDelete: Boolean
  },
  computed: {
    ...mapGetters({
      user: 'getViewUser',
      orgUpdateMemPending: 'getOrgUpdateMemPending',
      orgUpdateMemSuccess: 'getOrgUpdateMemSuccess',
      orgUpdateMemFailure: 'getOrgUpdateMemFailure'
    })
  },
  data: function () {
    return {
      selectedOrgAdmin: false,
      selectedOrgManager: false,
      spinnerColor: '#0F347B',
      spinnerSize: '50px'
    }
  },
  watch: {
    orgUpdateMemSuccess: function (newValue) {
      if (this.showModal) {
        _.delay(this.reset, 1000)
      }
    },
    showModal (newValue) {
      if (newValue) {
        this.selectedOrgAdmin = this.selectedMemRec.isOrgAdmin
        this.selectedOrgManager = this.selectedMemRec.isManager
        this.selectedDWUser = this.selectedMemRec.isDWUser
        this.selectedCareCoordinator = this.selectedMemRec.isCareCoordinator
      }
    }
  },
  methods: {
    getCreatedAt () {
      const selectedMemRec = this.selectedMemRec
      if (selectedMemRec.createdAt && selectedMemRec.createdAt.includes('T')) {
        return this.$utils.formatDate(selectedMemRec.createdAt)
      } else if (selectedMemRec.createdAt) {
        return this.$utils.unixToHuman(selectedMemRec.createdAt / 1000)
      }
    },
    getLastUpdateDate: function () {
      const selectedMemRec = this.selectedMemRec
      if (selectedMemRec.updatedAt && selectedMemRec.updatedAt.includes('T')) {
        return this.$utils.formatDate(selectedMemRec.updatedAt)
      } else if (selectedMemRec.updatedAt) {
        return this.$utils.unixToHuman(selectedMemRec.updatedAt / 1000)
      }
    },
    reset: function () {
      this.$emit('update:showModal', false)
      this.$store.commit('resetOrgUpdateMembership')
    },
    orgMemberHandler () {
      if (this.selectedMemRec) {
        this.$store.dispatch('updateOrgUserMembership', {
          id: this.selectedMemRec.id,
          morganization: this.selectedMemRec.morganization,
          data: {
            isOrgAdmin: this.selectedOrgAdmin,
            isManager: this.selectedOrgManager,
            isDWUser: this.selectedDWUser,
            isCareCoordinator: this.selectedCareCoordinator
          }
        })
      }
    },
    orgMemberHandlerDelete () {
      if (this.selectedMemRec) {
        this.$store.dispatch('deleteOrgUserMembership', {
          id: this.selectedMemRec.id
        })
      }
    },
    apiResponseMessage () {
      return (!this.orgUpdateMemFailure) ? 'Success' : '<p>' + this.orgUpdateMemFailure + '</p>'
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Admin/UpdateOrganizationsMemberModal.vue